import { useSelector } from "@xstate/store-react";
import { type CommandView, paletteStore } from "./palette-store";

export const usePaletteOpen = () => useSelector(paletteStore, (s) => s.context.open);
export const usePaletteView = () => useSelector(paletteStore, (s) => s.context.view);

export const usePaletteActions = () => ({
  open: (view?: CommandView) => paletteStore.send({ type: "palette.open", view }),
  close: () => paletteStore.send({ type: "palette.close" }),
  setView: (view: CommandView) => paletteStore.send({ type: "palette.setView", view }),
});
